/**
 * @generated SignedSource<<8fa0931e9b92dcb122d08142e65e6704>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedLowerShippingInfo_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPrice_viewer">;
  readonly " $fragmentType": "PdpSharedLowerShippingInfo_viewer";
};
export type PdpSharedLowerShippingInfo_viewer$key = {
  readonly " $data"?: PdpSharedLowerShippingInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedLowerShippingInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedLowerShippingInfo_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "018c0b91c13f41d188d939ac5b0b8201";

export default node;
